<div class="header-container main-font">
  <div
    class="main-title d-flex gap-3 align-items-center"
    [ngClass]="isSidebarHovered ? 'hover-header-position' : 'header-position'">
    <button
      (click)="goBack()"
      nz-tooltip="Torna indietro"
      nzTooltipPlacement="bottom"
      class="transparent-btn d-flex align-items-center"
      *ngIf="showGoBackButton">
      <i class="icons arrow-left fill-svg-blue-700"></i>
    </button>
    <p class="mb-0 section-title">{{ pageTitle }}</p>
    <button
      *ngIf="canShowInfo()"
      nz-popconfirm
      [nzPopconfirmTitle]="getDescription()"
      nzPopconfirmPlacement="rightTop"
      [nzIcon]="iconTpl"
      [nzPopconfirmOverlayStyle]="{ width: '750px' }"
      class="transparent-btn">
      <img src="assets/images/Shared/info_gray.svg" alt="info" />
    </button>
    <ng-template #iconTpl>
      <span
        nz-icon
        nzType="question-circle"
        nzTheme="fill"
        class="color-icon"></span>
    </ng-template>
  </div>
  <div class="d-flex justify-content-between gap-4">
    <div class="d-flex align-items-center gap-3 w-100">
      <button
        class="transparent-btn action-btn"
        routerLink="impostazioni-admin"
        nz-tooltip="Impostazioni admin"
        *ngIf="
          isAdmin ||
          roleUserLogged == 'project_manager' ||
          roleUserLogged == 'hr_manager'
        ">
        <i class="icons settings fill-svg-blue-700"></i>
      </button>
      <!-- COMMENTO TEMPORANEO il commento si toglierà una volta riviste le notifiche -->
      <!-- <button class="transparent-btn action-btn">
        <i class="icons bell fill-svg-blue-700"></i>
      </button> -->
    </div>
    <button
      class="transparent-btn user-btn"
      nz-popover
      nzPopoverTrigger="click"
      nzPopoverPlacement="bottomRight"
      [nzPopoverContent]="contentTemplate">
      <img
        [src]="_utilityService.getSanitizeUrl(loggedUser?.filestorage?.path)"
        alt="user"
        class="user-image" />
    </button>
    <ng-template #contentTemplate>
      <div class="pop-container">
        <div class="d-flex align-items-center flex-column w-100 my-bb gap-2">
          <img
            [src]="
              _utilityService.getSanitizeUrl(
                loggedUser ? loggedUser.filestorage?.path : ''
              )
            "
            alt="user"
            class="user-image" />
          <button class="transparent-btn" routerLink="profilo-utente">
            <p class="text-user mb-2">
              {{ loggedUser?.first_name }} {{ loggedUser?.last_name }}
            </p>
          </button>
        </div>
        <button
          class="transparent-btn d-flex align-items-center gap-2"
          (click)="logout()">
          <i class="icons log-out fill-svg-blue-700"></i>
          <p class="mb-0 text-logout">Log out</p>
        </button>
      </div>
    </ng-template>
  </div>
</div>
